import dva from 'dva';
import { message } from 'antd';
import { browserHistory } from 'dva/router';
import { createBrowserHistory as createHistory } from 'history';
//import modelMeta from '../models/meta';

/**
 *
 * @param opt
 *  target: DOM id
 * @constructor
 */

//const PATH_MODEL = '../models/';
//const PATH_ROUTER = '../pages/';

const InitApp = (opt) => {
  console.info('[InitApp]',opt);
  const id = '#'+opt.id;

  delete opt.ds.key;

//  let meta = {...opt.ds};
//  meta.id = opt.id;
//  meta.key = opt.key;
//  meta.page = (meta.page)?parseInt(meta.page):0;
//  meta.test = (meta.test)?parseInt(meta.test):0;
//  console.info('ds.meta', meta);

//  const initialState = {meta: meta};

  const initialState = {};
  initialState[opt.key] = {...opt.ds};     // register application key

  console.info(id, initialState);

  // 1. Initialize
  const app = dva({
    history: createHistory(),
    initialState: initialState,
    onError(e) {
      console.error(e);
//      alert(e.message);
      message.error(e.message, 3);
    },
  });

  // set extend parameters
  app.appkey = opt.key;


  // 2. Plugins
  //app.use(createLoading());

  // 3. Model
  /*
  if(opt.models) {
    opt.models.map(model => {
      app.model(require('../models/' + model).default);
    });
  }
  */
  app.model(require('../pages/' + opt.key + '/models/'+ opt.key).default);

  // 4. router
  app.router(require('../pages/' + opt.key + '/config/router').default);

  // 5. Start
  app.start(id);
};

export default InitApp;


// WEBPACK FOOTER //
// ./src/components/InitApp.js